import { Link, usePage } from '@inertiajs/react'
import Monogram from './Monogram'
import { isPlayed, hasPenalties, homeWins, awayWins } from '../lib/result'

export default function FixtureCard({ match }) {
  const slug = usePage().props.currentEdition.slug
  const live = match.status === 'live'
  const played = isPlayed(match)
  const hasTeams = match.home && match.away

  const fxClass = ['fx', live ? 'live' : '', !live && !played ? 'pending' : ''].filter(Boolean).join(' ')
  const cpClass = ['cp', match.field === 2 ? 'c2' : '', live ? '' : ''].filter(Boolean).join(' ')

  return (
    <Link href={`/${slug}/jogo/${match.gameNumber}`} className={fxClass}>
      <span className={cpClass}>{match.field ? `C${match.field}` : 'KO'}</span>

      {hasTeams ? (
        <>
          <div className="teams">
            <div className={`t ${homeWins(match) ? 'win' : ''}`}>
              <Monogram team={match.home} size={20} />
              {homeWins(match) ? <b>{match.home.shortName}</b> : match.home.shortName}
            </div>
            <div className={`t ${awayWins(match) ? 'win' : ''}`}>
              <Monogram team={match.away} size={20} />
              {awayWins(match) ? <b>{match.away.shortName}</b> : match.away.shortName}
            </div>
          </div>
          <div className="res">
            <span className={homeWins(match) ? 'w' : ''}>
              {played ? match.homeScore : '–'}
              {hasPenalties(match) && <small className="pens"> ({match.homePenalties})</small>}
            </span>
            <span className={awayWins(match) ? 'w' : ''}>
              {played ? match.awayScore : '–'}
              {hasPenalties(match) && <small className="pens"> ({match.awayPenalties})</small>}
            </span>
          </div>
        </>
      ) : (
        <>
          <div className="teams">
            <div className="t"><b>{match.label}</b></div>
          </div>
          <div className="res">
            <span>{played ? match.homeScore : '–'}</span>
            <span>{played ? match.awayScore : '–'}</span>
          </div>
        </>
      )}

      {live && <span className="livetag">● ao vivo</span>}
    </Link>
  )
}
